// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__is1vr","menu":"Sidebar_menu__7+RxN","border":"Sidebar_border__fXkTq"};